import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
export default withAllhomesContext('isEuUser');